import {useEffect, useMemo, useState} from "react";
import {useRestClient} from "../client/SpmRestClient";
import {Spinner} from "react-bootstrap";
import {useAlerts} from "../utils/UserAlerts";
import {GenericSelectOption, StringSelect} from "zavadil-react-common";
import {NodeWarningType} from "../types/NodeWarning";

export type SelectNodeWarningTypeProps = {
	typeId?: string | null;
	onChange(typeId?: string | null): any;
}

export default function SelectNodeWarningType({typeId, onChange}: SelectNodeWarningTypeProps) {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [types, setTypes] = useState<Array<NodeWarningType>>();

	useEffect(
		() => {
			restClient.check.types()
				.then(setTypes)
				.catch((e) => userAlerts.err(e));
		},
		[]
	);

	const options: GenericSelectOption<string>[] = useMemo(
		() => types ? types.map(
			(t) => {
				return {
					id: t.id,
					label: t.name
				}
			}) : [],
		[types]
	);

	return types ? <StringSelect
		options={options}
		value={typeId}
		onChange={onChange}
		showEmptyOption={true}
	/> : <Spinner/>
}
